import { Trans } from "@lingui/macro";
import { useEffect, useState } from "react";
import { Soribot } from "../../models/Soribot";
import { UserSimplified } from "../../models/User";
import ProfileImg from "../components/ProfileImg";
import { SoribotRoomsSettingModal } from "./SoribotRoomsSettingModal";
import { Avatar, AvatarFallback } from "../../components/ui/avatar";
import { Link } from "react-router-dom";

export const SoribotRooms: React.FC<{ bot: Soribot }> = ({ bot }) => {
  const [roomMembers, setRoomMembers] = useState<UserSimplified[]>([])

  useEffect(() => {
    const allUsers = bot.rooms.flatMap(room => room.users);
    const uniqueUsers = Array.from(new Map(allUsers.map(user => [user.id, user])).values());
    setRoomMembers(uniqueUsers);
  }, [bot])

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h6 className="text-lg font-semibold"><Trans>Room list</Trans></h6>
        <SoribotRoomsSettingModal bot={bot} />
      </div>

      <div className="min-h-[22vh] border rounded divide-y bg-white">
        {bot.rooms.map((room) =>
          <div key={room.id} className="p-3 hover:bg-gray-50 transition-colors">
            <Link to={`/room/${room.id}`} className="block">
              <div className="font-medium text-sm"># {room.name}</div>
              <div className="text-xs text-gray-500 mt-1"><Trans>{room.userIds.length} members</Trans></div>
            </Link>
          </div>
        )}
        {bot.rooms.length === 0 && <div className="p-4 text-center text-gray-500 text-sm"><Trans>No rooms connected</Trans></div>}
      </div>

      <div className="space-y-4">
        <h6 className="text-lg font-semibold"><Trans>All room members</Trans></h6>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          {roomMembers.map((u) => {
            return <div key={u.id} className="flex items-center gap-3 p-3 rounded border bg-white">
              <Avatar className="w-8 h-8">
                <ProfileImg url={u.photoUrl} className="object-cover" />
                <AvatarFallback>{u.name[0]}</AvatarFallback>
              </Avatar>
              <div className="text-sm font-medium truncate">{u.name}</div>
            </div>
          })}
        </div>
        {roomMembers.length === 0 && <div className="text-gray-500 text-sm"><Trans>No members found</Trans></div>}
      </div>
    </div>
  );
}
export default SoribotRooms;